<template>
  <div>{{ActDescBtn}}
    <v-card class="overflow-hidden">
    <!-- <v-app-bar
      absolute
      color="white"
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
 
      <v-toolbar-title>{{titulo}}</v-toolbar-title>
      
      <v-spacer></v-spacer>
      <v-card flat class="">
        <v-card-text>
          <v-row align="center" justify="center">
            <v-btn-toggle v-model="toggle_exclusive" mandatory>
              <v-btn color="warning" dark
               small >Nuevo
                <v-icon dark left>mdi-file</v-icon>
              </v-btn>

              <v-btn color="success" dark
               small >Salvar
                <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
              </v-btn>

              <v-btn color="red" dark
               small >Eliminar
                <v-icon dark right>mdi-cancel</v-icon>
              </v-btn>

              <v-btn color="blue" dark
              small  >Imprimir
                <v-icon dark left>mdi-printer-check</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-row>
        </v-card-text>
      </v-card>
    </v-app-bar>

    <v-sheet
      id="scrolling-techniques-7"
      class="overflow-y-auto"
      max-height="1000px"
    >
      <v-container style="height:500px;"> -->
<!-----------------cuerpo del  componente ---------------->

<v-container>
  <v-card color="grey lighten-2" v-ripple="{ class: `indigo--text` }" >
  <v-container style="border: 1px solid #000000;">

<center><h3> SOLICITUD DE CHEQUE</h3></center>

<!-- <img id="img-footer-mini" src="../assets/log.png" class="ma-2 "> -->
<v-img style="height: 60px; width:140px; border-radius: 2px;" :src="getImgUrl()"></v-img>
<!-- <v-avatar 
 size="100"
  tile >
                  
</v-avatar> -->

  
  <v-form ref="formSolicitud" v-model="valid" lazy-validation>
              <v-row>
<!-- columna 1 ----------------------------------------------->
                <v-col cols="12" md="6" sm="6">

<!-- -----------------------------  fecha  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="FECHA:"
        v-model="Cheques.fecha"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>
  
</v-text-field>


                </v-col>
<!-- fn columna 1 ------------------------------------------->

<!-- columna 2  --------------------------------------------->
                <v-col cols="12" md="6" sm="6">

<!-------------------------------------------------------- no -->

<v-text-field label="NO. :"
                     dense outlined
                     v-model="Cheques.referencia"
                     autocomplete="off"
             
                     :rules="[$rules.required]"
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-slack"></i> 
                      </template>
                    </v-text-field>

                </v-col>
<!-- fn columna 2  ------------------------------------------>

<!-- columna 3 ----------------------------------------------->
                <v-col cols="12" md="12" sm="12">

<!-------------------------------------------------------- Cuenta  -->
<!--@blur="SelctCbOperacion" @focus="CargarROperacion"  -->

<v-combobox
                    v-model="Cheques.Cuentabancaria"
                    label="SIRVASE AUTORIZAR ESTE DOCUMENTO CONTRA EL BANCO:"
                    required
                    outlined
                    dense
                    :rules="[$rules.required]"
                    autocomplete="off"
                    :items="[]"
                    item-text="descripcion"
                    
                    
                  >  
                          <template v-slot:prepend>
                            <i
                              style="font-size: 20px;"
                              class="fa fa-check-square-o"
                            ></i>
                          </template>
</v-combobox>

<!-------------------------------------------------------- beneficio -->
                    <v-text-field label="BENEFICIARIO:"
                     dense outlined
                     v-model="Cheques.descripcion"
                     :rules="[$rules.required]"
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-address-book-o"></i> 
                      </template>
                    </v-text-field>


<!-------------------------------------------------- Valor-->
<VueAutonumeric label="POR LA SUMA DE:" 
  dense 
  outlined
 autocomplete="off"
  v-model.number="Cheques.valor"
  :rules="[$rules.required]" 
  >
    <template v-slot:prepend>
      <i style="font-size: 20px;" class="fa fa-money"></i>
    </template>
  </VueAutonumeric>



<!-------------------------------------------------------- beneficio -->
                    <v-textarea label=""
                     dense outlined
                     rows="2"
                     v-model="Cheques.descripcion"
                     :rules="[$rules.required]"
                     disabled
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-info-circle"></i> 
                      </template>
                    </v-textarea>

<!-- ----------------------------- comentario -->
              
                  <v-textarea
                  autocomplete="off"
                    label="POR CONCEPTO:"
                    rows="2"
                    dense
                    outlined
                    v-model="Cheques.concepto"
                    
                  >
                    <template v-slot:prepend>
                      <i style="font-size: 20px;" class="fa fa-commenting"></i>
                    </template>
                  </v-textarea>


<v-text-field label="Hora"
                     dense outlined
                     v-model="Cheques.referencia"
                     autocomplete="off"
                     type="time"
             
                     :rules="[$rules.required]"
                     >
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-slack"></i> 
                      </template>
                    </v-text-field>

                </v-col>
<!-- fn columna 3  --------------------------------->





              </v-row>
            </v-form>

 </v-container>
  </v-card>

<v-row>
</v-row>


<v-data-table
      v-ripple="{ class: `indigo--text` }"
      :single-select="false"
      item-key="codigo"
      show-select
      class="elevation-1"
      dense
      v-model="selectedSolicitud"
  :headers="[{ text: 'FECHA', value: 'fecha',width:'auto'},{ text: '# SOLICITUD', value: 'solicitud',width:'auto'},
{ text: 'BENEFICIARIO', value: 'beneficio',width:'auto'},{ text: 'BANCO', value: 'banco',width:'auto'},
{ text: 'VALOR', value: 'valor',width:'auto'},{ text: 'ACCIÓN', value: 'action',width:'auto'}]"
        :items="ListSolicitud"

        :items-per-page="-1"
      >
     <template v-slot:item.action="{ item }"> 
<!-- <v-btn fab @click.prevent="editFact(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>  -->
<v-btn fab  x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>        
   </template>

<template v-slot:item.valor="props">
    <span>0</span>
    </template>


 <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<!-- <td class="border-top-bottom"  ><strong></strong></td> -->
                                                                                
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:15px; color: #00838F;">Total:</strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> 0 </strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
<!-- <td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(form.TotalProd.importe)}} </strong></td> -->
<!-- <td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(form.Total.Total)}} </strong></td> -->
<td class="border-top-bottom"  ><strong></strong></td>
  </tr>
 </template>

 <template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>TOTAL VALOR:5</span>
      </v-list-item-content>
    </v-list-item>

  </template>
    </v-data-table>




 </v-container>




<v-sheet 
                :color="`grey ${theme.isDark ? 'darken-2' : 'darken-1'}`"
                class="px-3 pt-3 pb-3"
              >
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="auto"
                  type="card"
                ></v-skeleton-loader>
              </v-sheet>

<v-btn id="boton-mini"
                  color="teal darken-2"
                  dark
                  small
                
                  @click.prevent="Ejecu"
                  >Ver

                  <i style="font-size: 25px;" class="fa fa-eye"> </i>
                
                </v-btn>

                <v-text-field
                  name="name"
                  label="label"
                  v-model.number="intt"
                ></v-text-field>




  <v-progress-circular
      :size="70"
      :width="7"
      color="purple"
      indeterminate
    ></v-progress-circular>


<v-progress-circular
      :rotate="360"
      :size="100"
      :width="15"
      :value="value"
      color="teal"
    >
      {{ value }}
    </v-progress-circular>


<v-progress-linear

      color="deep-purple lighten-2"
      height="18"
      :value="value"
      rounded
      striped
    >
    <template v-slot="{ value }">
        <strong>{{ Math.ceil(value)}}%</strong>
      </template>
    
    </v-progress-linear>
<br>

    <v-progress-linear
      color="red lighten-2"
      height="15"
      :buffer-value="value"
      stream
    ></v-progress-linear>
<br>
<v-progress-linear
      v-model="value"
      color="blue-grey"
      height="25"
    >
      <template v-slot="{ value }">
        <strong>{{ Math.ceil(value) }}%</strong>
      </template>
    </v-progress-linear>

<br><br><br><br> 

<template>

<v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>


  <v-data-table
  @click:row="obtenerDato"
  :search="search"
  hide-default-header
  dense :headers="[{ text: 'FECHA', value: 'fecha',width:'auto'},{ text: '# SOLICITUD', value: 'solicitud',width:'auto'},
{ text: 'BENEFICIARIO', value: 'beneficio',width:'auto'},{ text: 'BANCO', value: 'banco',width:'auto'},
{ text: 'VALOR', value: 'valor',width:'auto'}, {text:'sucursal', value:'sucursal.nombre'}]" 
:items="ListSolicitud" item-key="codigo" class="elevation-1">

<!--<template slot="item" slot-scope="item" margin-top="50px">
<span>{{item.item}}
 <v-col cols="6" md="6">({{item.item.tipo}}): {{item.item.cuenta }}</v-col>
<v-col cols="6" md="6">{{ item.item.descripcion}}</v-col> 
</span></template>-->

 <template v-slot:item="props"> 
<!-- <v-col cols="12" md="12" sm="12">
{{props.item}}
</v-col>
<hr> -->

<!-- Notas:
  {Text: Se refiere al nombre descriptivo,
   NomValue: se refiere al primer nombre del objecto,
   Nv2: se refiere al seg nombre objecto, Nv3: al tercero, 
   Ctsl: cantidad de slot de objecto que pose,  
   Type: se refiere al tipo:(texto=0,fecha=1, numerico=2), 
   State: 
   }


   
   -->

        <tr>
          <td @click.prevent="obtenerDato(props.item)"  v-ripple="{ class: `indigo--text` }" >
  
      <v-list-item-content>
<span v-for="(sl, i) in ContListSlot" :key="i">
  
      <span v-if="props.item.hasOwnProperty(sl.NomValue)">

    <span v-if="sl.Ctsl==1"><b>{{sl.Text}}: </b>
        <span v-if="sl.Type==0">{{props.item[sl.NomValue]}}.</span>
        <span v-if="sl.Type==1">{{FormatoFecha(props.item[sl.NomValue])}}.</span>
        <span v-if="sl.Type==2">{{currencyFormatter(props.item[sl.NomValue])}}.</span>
    </span>

    <span v-if="sl.Ctsl==2 & props.item[sl.NomValue].hasOwnProperty(sl.Nv2)"><b>{{sl.Text}}: </b>
        <span v-if="sl.Type==0">{{props.item[sl.NomValue][sl.Nv2]}}.</span>
        <span v-if="sl.Type==1">{{FormatoFecha(props.item[sl.NomValue][sl.Nv2])}}.</span>
        <span v-if="sl.Type==2">{{currencyFormatter(props.item[sl.NomValue][sl.Nv2])}}.</span>
    </span>

    <span v-if="sl.Ctsl==3 & props.item[sl.NomValue].hasOwnProperty(sl.Nv2)">
      <span v-if="props.item[sl.NomValue][sl.Nv2].hasOwnProperty(sl.Nv3)"><b>{{sl.Text}}: </b>
        <span v-if="sl.Type==0">{{props.item[sl.NomValue][sl.Nv2][sl.Nv3]}}.</span>
        <span v-if="sl.Type==1">{{FormatoFecha(props.item[sl.NomValue][sl.Nv2][sl.Nv3])}}.</span>
        <span v-if="sl.Type==2">{{currencyFormatter(props.item[sl.NomValue][sl.Nv2][sl.Nv3])}}.</span>
    </span>
    </span>


  </span> 
</span>  
      </v-list-item-content>
     
            </td>
        </tr>
        <hr>

<!-- <span>{{props.item}}
  </span> -->
 </template>
  </v-data-table>
  </template>

<br><br><br><br> 


<v-file-input :rules="[$rules.required]" type="file" @change="" v-model="datoOBj" id="excelActPrecio" dense
                  outlined show-size counter multiple label="Archivo"
                  >           
                  <template v-slot:append-outer>

<v-tooltip top>
  <template v-slot:activator="{ on }">

    <v-btn @click.prevent="descargar" v-on="on" color="blue" fab x-small
      dark>
      <i style="font-size: 20px;" class="fa fa-cloud-upload"></i>
    </v-btn>

  </template>
  <span>Subir Archivo</span>
</v-tooltip>
</template>
                </v-file-input>


                <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn id="boton-mini" v-on="on" color="success" small
                                @click.prevent="dialogReimprecion=true">
                                <i style="font-size: 20px;" class="fa fa-question-circle-o"> </i>
                                    OPEN
                              </v-btn>
                            </template>
                            <span>OPEN</span>
                          </v-tooltip>



<!-- btn 1  -->
<v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn id="boton-mini" v-on="on" color="success" small
                                @click.prevent="EJECPDF">
                                <i style="font-size: 20px;" class="fa fa-question-circle-o"> </i>
                                SP
                              </v-btn>
                            </template>
                            <span>Solicitud Pendiente</span>
                          </v-tooltip>
                          <!-- fn btn 1 -->


<!-- btn 1  -->
<v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn id="boton-mini" v-on="on" color="success" small
                                @click.prevent="ImprimirPDF">
                                <i style="font-size: 20px;" class="fa fa-question-circle-o"> </i>
                               IMPRIMIR PDF
                              </v-btn>
                            </template>
                            <span>IMPRIMIR PDF</span>
                          </v-tooltip>
                          <!-- fn btn 1 -->


                          <br> </br>
<h4>---Open--</h4>
<v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn id="boton-mini" v-on="on" color="success" small
                                @click.prevent="openDialogPdfViewer">
                                <i style="font-size: 20px;" class="fa fa-question-circle-o"> </i>
                                    OPEN
                              </v-btn>
                            </template>
                            <span>OPEN</span>
                          </v-tooltip>

                          <br> </br>
<h4>---Prueba Salud Dominicana--</h4>

  <div >
                      <v-text-field label="QRYS:" dense outlined v-model="qry">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-list-ol"></i>
                          </template>
                        </v-text-field>

                      <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getDataNewService" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    SALUD DOMINICANA
                  </v-btn>
                </template>
                <span> Obtener informacion web service</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="saveUpdatDataCliente" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    PR SAVEUPDATE SALUD DOMINICANA
                  </v-btn>
                </template>
                <span>PR SAVEUPDATE SALUD DOMINICANA </span>
              </v-tooltip>
                      </div>


<!-- Pruebas Dgii -->
                      <br> </br>
             <div>
                      <v-text-field label="QRYS:" dense outlined v-model="dgiUrl">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-list-ol"></i>
                          </template>
                        </v-text-field>


                        <center><h2>--------------Service dgi----------</h2> </center>

<v-file-input :rules="[$rules.required]" type="file" @change="" v-model="archivoKey" id="archivoKey" dense
                  outlined show-size counter multiple label="Archivo key"
                  accept=".p12,.txt,.xml">
                  
                  <template v-slot:append-outer>

<v-tooltip top>
  <template v-slot:activator="{ on }">

    <v-btn v-if="false" @click.prevent="SubirArchivoPro" v-on="on" color="blue" fab x-small
      dark>
      <i style="font-size: 20px;" class="fa fa-cloud-upload"></i>
    </v-btn>

  </template>
  <span>Subir Archivo</span>
</v-tooltip>
</template>
</v-file-input>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getSemillaValidaGetToken" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    PRUE DGI: OBTENER SEMILLA
                  </v-btn>
                </template>
                <span> Obtener informacion web service</span>
              </v-tooltip>

                      <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getService" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    PRUE DGI: OBTENER SELLO
                  </v-btn>
                </template>
                <span> Obtener informacion web service</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="varlidarSemilla()" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    PRUE DGI: VALIDAR SEMILLA 
                  </v-btn>
                </template>
                <span> Obtener informacion web service</span>
              </v-tooltip>



              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getPRFacturaECF" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    PRUE DGI: PR FACTURA ECF
                  </v-btn>
                </template>
                <span> Obtener informacion web service</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getPRFacturaRFCE" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    PRUE DGI: PR FACTURA RFCE
                  </v-btn>
                </template>
                <span> Obtener informacion web service</span>
              </v-tooltip>




            <br></br>

            <v-file-input :rules="[$rules.required]" type="file" @change="" v-model="archivoKeyBase64" id="archivoKey" dense
                  outlined show-size counter multiple label="Archivo a base64"
                  accept=".p12">
                  <template v-slot:append-outer>
            </template>
          </v-file-input>


          <v-file-input :rules="[$rules.required]" type="file" @change="" v-model="archivoKey" id="archivoKey" dense
                  outlined show-size counter multiple label="Archivo key"
                  accept=".p12,.txt,.xml"> 
          </v-file-input>

                                                              <!--convertirBase64  -->
            <v-tooltip bottom>
                <template v-slot:activator="{ on }"> 
                  <v-btn id="boton-mini" v-on="on" @click="getTobase64P12" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    PRUE DGI: Converir en base64
                  </v-btn>
                </template>
                <span> Obtener informacion web service</span>
              </v-tooltip>


           </div>

<!-- fin Pruebas Dgii -->
<br> </br><br> </br><br> </br><br> </br><br> </br><br> </br> <br> </br><br> </br><br> </br>

<center><h2>-------------- FACTURACION ELETRONICA ----------</h2> </center>
<v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0" style="border: 1px solid #000000;">
<v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0" style="border: 1px solid #000000;">
  <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getSemillaValidaGetToken" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    DGI: OBTENER TOKEN
                  </v-btn>
                </template>
                <span> Este metodo genera la semilla,coloca el sello p12, valida la semilla y obtiene el token</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getFacturaRFCE" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     DGI: Sellar Factura RFCE
                  </v-btn>
                </template>
                <span> Este metodo toma la factura en objecto la convierte en xlm y la sella con p12 y genera el archivo</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getFacturaECF" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     DGI: Sellar Factura ECF
                  </v-btn>
                </template>
                <span> Este metodo toma la factura en objecto la convierte en xlm y la sella con p12 y genera el archivo</span>
              </v-tooltip>


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getAprovacion" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     DGI: Aprobacion
                  </v-btn>
                </template>
                <span> Este metodo genera la aprobacion comercial</span>
              </v-tooltip>



              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="soloFacXMLECF" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     SOLO: CONVERTIR FACT A XML ECF
                  </v-btn>
                </template>
                <span> SOLO: CONVERTIR FACT A XML ECF</span>
              </v-tooltip> 

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="soloFacXMLRFCE" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     SOLO: CONVERTIR FACT A XML RFCE
                  </v-btn>
                </template>
                <span> SOLO: CONVERTIR FACT A XML RFCE</span>
              </v-tooltip> 

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="soloImpFac" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     SOLO: IMPRIMIR FACTURA
                  </v-btn>
                </template>
                <span> SOLO: IMPRIMIR FACTURA</span>
              </v-tooltip> 

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="soloImpNOTA" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     SOLO: IMPRIMIR NOTA CREDITO
                  </v-btn>
                </template>
                <span> SOLO: IMPRIMIR NOTA CREDITO</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="buscarSingn" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     Buscar Singn
                  </v-btn>
                </template>
                <span> Buscar Singn</span>
              </v-tooltip>   


      <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="facttemObjnoCoincide" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                     Crear Fac TEMP
                  </v-btn>
                </template>
                <span> Crear Fac TEMP</span>
              </v-tooltip>            

</v-col>

<v-row >

  <v-col cols="12" md="6" sm="6">
  <v-textarea autocomplete="off" label="TOKEN GENERADO:" rows="3" dense outlined hide-details
                        v-model="token">
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" @click="token=''" class="fa fa-pencil-square-o"></i>
                        </template>
 </v-textarea>
</v-col>

<v-col cols="12" md="6" sm="6">
  <v-textarea autocomplete="off" label="OBJCTO FACTURA:" rows="3" dense outlined hide-details
                        v-model="objFactura">
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" @click="objFactura=''" class="fa fa-pencil-square-o"></i>
                        </template>
 </v-textarea>
</v-col>

<v-col cols="12" md="12" sm="12">
  <v-textarea autocomplete="off" label="QR:" rows="2" dense outlined hide-details
                        v-model="qrdgii">
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" @click="qrdgii=''" class="fa fa-pencil-square-o"></i>
                        </template>
 </v-textarea>
</v-col>



</v-row>



</v-col>

</br><br> </br>

<center><h2>-------------- Simulacion FACTURACION ELETRONICA ----------</h2> </center>
<v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0" style="border: 1px solid #000000;">
  
  <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getProcesoCompletoECF" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    DGI: SIMULACION FACT ECF
                  </v-btn>
                </template>
                <span> PROCESO COMPLETO FACT ECF</span>
              </v-tooltip>

  
  <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getProcesoCompletoRFCE" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    DGI: SIMULACION FACT RFCE
                  </v-btn>
                </template>
                <span> PROCESO COMPLETO FACT RFCE</span>
              </v-tooltip>

          
</v-col>

 <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="getProcesoPr_ECF_NotaCredito" color="blue" small dark>
                    <i style="font-size: 20px;" class="fa fa-cloud-upload"> </i>
                    DGI: PR NOTA CREDITO CLIENTE
                  </v-btn>
                </template>
                <span> PR  PR NOTA CREDITO CLIENTE</span>
              </v-tooltip>
<!-- <center><h2>--------------fn Service dgi Org----------</h2> </center> -->
<br> </br><br> </br><br> </br>

<div>
    <h3>Contenido incrustado</h3>
   <a 
  :href="`https://ecf.dgii.gov.do/testecf/consultatimbre?rncemisor=130412881&rnccomprador=103003941&encf=E310000001471&fechaemision=24-02-2026&montototal=500.00&fechafirma=25-02-2026%2008:52:00&codigoseguridad=TKvjtz`"
  target="_blank"
  rel="noopener noreferrer"
>
  Ver documento
</a>
  </div>


                  <v-text-field id="formdisabledInput" 
                                      autocomplete="off" dense class="fontSize12"
                                       hide-details label="NOMBRE" outlined 
                                       @focus="verEvent($event)"
                                       @blur="verEvent($event)"
                                       >
                        </v-text-field>



<br> </br><br> </br><br> </br>
<br> </br><br> </br><br> </br>
<br> </br><br> </br><br> </br>
<br> </br><br> </br><br> </br>
<br> </br><br> </br><br> </br>


<v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0" style="border: 1px solid #000000;"></v-col>
hola mundo klk mundo


<VueAutonumeric type="text" label="autotext" id="formdisabledInput"  dense outlined 
                          autocomplete="off" :rules="[$rules.Numericc]" v-model="autotext"
                          style="font-size:13px;">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-usd"></i>
                          </template>
                        </VueAutonumeric>


<!-- id="formdisabledInput" -->
<v-text-field label="autotext" dense outlined v-model="autotext" hide-details
                        class="fontSize11 fino-input" id="formdisabledInput" autocomplete="off"
                       style="min-height: 30px; padding-top: 1px; padding-bottom: 1px;" >
                        </v-text-field>



<v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0">
<v-btn  @click.prevent="getSecuenciaAlfNum" v-on="on" color="blue" outlined  small dark>
                                                <i style="font-size: 20px;" class="fa fa-plus-square"></i> GETSECUENCIA
                                                </v-btn>
</v-col>

 


</v-col>



<v-card
     v-ripple="{ class: `indigo--text` }"
    
      :color="active ? 'primary' : undefined"
      :dark="active"
      class="mx-auto"
      height="80"
      rounded="xl"
      width="100" 
      v-click-outside="onClickOutside"
      @click="active = true"
    >
      <v-container>
    <center>
      <v-avatar tile  size="36"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
    <center><p>Producto</p></center>
  </v-container>
        
    </v-card>

    <br><br><br><br>
    <p>Hola mundo</p>
    <div class="text-center">
      
      <v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        @click.prevent="Ejecu"
        > 
   <v-container>
    <center>
    <v-icon>mdi-pencil</v-icon>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>
        
      </v-hover>
      
      
      <v-btn class="ma-2" outlined fab color="teal">
        <v-icon>mdi-format-list-bulleted-square</v-icon>
      </v-btn>
      
      <v-btn class="ma-2"  rounded="xl"  outlined x-large fab color="red lighten-1">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>


      <v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        > 
   <v-container>
    <center>
    <v-avatar tile  size="36" :color="hover ? 'red' : 'grey darken-2'"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>
        
      </v-hover>


 <v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        > 
   <v-container>
    <center>
    <v-avatar   size="36" :color="hover ? 'red' : 'grey darken-2'"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>   
      </v-hover>
      




     <v-chip
        class="ma-2"
        color="#dd4b39"
        outlined
        close
        @click:close="close"
      >
        <v-icon left>mdi-account-outline</v-icon>
        New Posts Available
       
      </v-chip> 
    </div>


<br><br><br>



<v-row>

<v-col cols="12" md="6" sm="6">

 <v-card color="grey lighten-3">
<v-row> 
 
<v-col cols="6" md="3" sm="3" >
<v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        > 
   <v-container>
    <center>
    <v-avatar   size="36" :color="hover ? 'red' : 'grey darken-2'"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>   
      </v-hover>

</v-col>

<v-col cols="6" md="3" sm="3" >
<v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        > 
   <v-container>
    <center>
    <v-avatar   size="36" :color="hover ? 'red' : 'grey darken-2'"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>   
      </v-hover>

</v-col>

<v-col cols="6" md="3" sm="3" >
<v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        > 
   <v-container>
    <center>
    <v-avatar   size="36" :color="hover ? 'red' : 'grey darken-2'"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>   
      </v-hover>

</v-col>

<v-col cols="6" md="3" sm="3" >
<v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        > 
   <v-container>
    <center>
    <v-avatar   size="36" :color="hover ? 'red' : 'grey darken-2'"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>   
      </v-hover>

</v-col>
<v-col cols="6" md="3" sm="3" >
<v-hover
        v-slot:default="{ hover }"
        close-delay="200"
      >
        
        <v-btn :elevation="hover ? 24 : 2" 
        :outlined="hover ? false : true" 
        dark
        :color="hover ? 'red' : 'grey darken-2'"
        v-ripple="{ class: `indigo--text` }"
        > 
   <v-container>
    <center>
    <v-avatar   size="36" :color="hover ? 'red' : 'grey darken-2'"  >
      <img
        src="https://cdn.vuetifyjs.com/images/john.jpg"
        alt="John"
      >
    </v-avatar>
    </center>
  <p>Producto</p>
         
  </v-container>
          
      </v-btn>   
      </v-hover>

</v-col>


</v-row>
</v-card>


</v-col>

</v-row>

<br><br>
<h3>Pruebas video</h3>
<!-- <video width="320" height="240" src="https://www.youtube.com/watch?v=eyppFPEAEuU" >
  Your browser does not support the video tag.
</video> -->

<!-- <iframe :src="`https://m.youtube.com/playlist?app=desktop&list=PLYQ3nAK35Rp10yr_bvF7B-nnldWxBetEI?controls=0`" frameborder="0" allowfullscreen="allowfullscreen"></iframe> -->
<!-- <iframe :src="`https://www.youtube.com/watch?v=6Z9yWHs5X2I&list=PLYQ3nAK35Rp10yr_bvF7B-nnldWxBetEI&index=1`" ></iframe>
<br><br><br><br><br> -->


<!-- <iframe width="420" height="345" :src="`https://www.youtube.com/watch?v=6Z9yWHs5X2I&list=PLYQ3nAK35Rp10yr_bvF7B-nnldWxBetEI&index=1?controls=0`">
</iframe> 
<iframe width="420" height="345" src="https://www.youtube.com/embed/tgbNymZ7vqY?controls=0">
</iframe>
-->

<!-- <iframe width="420" height="345" src="https://www.google.com/">
</iframe>
     -->
<!--------- fin cuerpo ----------------->
    <!-- </v-container>
    </v-sheet> -->
  </v-card>
<!-- ------------------------------------------------------ Modal Solicitud Pendiente -->

<v-dialog v-model="AprirSolicitudPendiente" persistent fullscreen hide-overlay
      transition="dialog-bottom-transition">

      <v-card>

        <v-col class="pa-0 ma-0 py-0 my-0 d-flex justify-end " style="background-color:#3F51B5;" cols="12" md="12"
          sm="12">
          <v-btn color="grey darken-4" fab x-small @click="AprirSolicitudPendiente=false">
            <i style="font-size: 20px; color:white;" class="fa fa-close"></i>
          </v-btn>

        </v-col>

        <v-list three-line subheader>
<!-- :height=600 width=100% :max-height=windowSize.height -->
          <iframe
          name="myiframe" 
        src="data:application/pdf;base64,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"
        
        v-bind:style="{ 'min-width': 100 + '%', 'height': windowSize.height+60  +'px', 'max-width': '100%' }">
        </iframe>

        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog label="Modal Reimprecion " v-model="dialogReimprecion" persistent fullscreen hide-overlay
      transition="dialog-bottom-transition">
      
      <v-card class="mx-auto">
        <label>HOLA MUNDO</label>

        <v-hover v-slot:default="{ hover }" close-delay="200">

<v-btn :elevation="hover ? 24 : 2" :outlined="hover ? false : true" dark block
  :color="hover ? 'blue darken-3' : 'blue'" v-ripple="{ class: `white--text` }"
  @click.prevent="EJECPDF">

  <h2>IMPRIMIR</h2>

</v-btn>
</v-hover>

      </v-card>
    </v-dialog>

<!-- ------------------------------------------------------ Modal PdfViewer -->  

<v-dialog v-model="dialogPdfViewer" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
  <v-card class="mx-auto">
    <ComponentsPdfViewer ref="RefComponentsPdfViewer"   @DataRetornCancelarPdfViewer="dialogPdfViewer= false" />
  </v-card>
</v-dialog>
<!-- fn PdfViewer------------------------------------------------------------------->

<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <ComponentsPvImprecionViewer ref="RefPvImprecionViewer" />
</div>

<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
</div>

 <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="aalert.timeout" :right="aalert.right" :top="aalert.top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>


  </div>
</template>

<script>
//import jsonFac from '@/prjson.json'
import { EventBus } from "@/event-bus";
import VueAutonumeric from "@/components/AutoNumericNuevo.vue";
import ComponentsPdfViewer from "@/components/PdfViewer.vue";
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
import { currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,RedondeoValor,RedondeoBasico,fechaNueva,getHoraActual } from "@/js/Funciones.js";
export default {
inject: ['theme'],
components: {
   
    VueAutonumeric,
    ComponentsPdfViewer,
    PvDgiiFacturacionEletronica
    
  
  },

  mounted() {
 
  },

data:()=>({

  aalert: {
      estado: false,
      color: null,
      timeout: 3000,
      top: false,
      right: false
    },
    notif: {
      estado: false,
      nombre: "",
      Exec: ""
    },

        autotext:"",
        token:'',
        objFactura:'',
        qrdgii:'',
        //myJson: jsonFac,
        archivoKey:null,
        archivoKeyBase64:null,
        dialogPdfViewer:false,
        qry:"",
        dgiUrl:"",
        dialogReimprecion:false,
        datoOBj:null,
        active: false,
        windowSize:{width:"auto", height:"auto"},
        search:'',
        toggle_exclusive:false,
        titulo:"Rutas",
        valid:true,
        selectedSolicitud:[],
        AprirSolicitudPendiente:false,
ContListSlot:[
{Text:'Código',NomValue:'codigo', Ctsl:1, Type:0, State:true},
{Text:'Banco',NomValue:'banco', Ctsl:1, Type:0, State:true},
{Text:'Beneficio',NomValue:'beneficio', Ctsl:1, Type:0, State:true},
{Text:'Fecha',NomValue:'fecha', Ctsl:1, Type:1, State:true},
{Text:'Valor',NomValue:'valor', Ctsl:1, Type:2, State:true},
{Text:'Sucursal',NomValue:'sucursal', Nv2:'nombre', Ctsl:2, Type:0, State:true},
{Text:'Documento',NomValue:'sucursal', Nv2:'documento', Nv3:'desc' ,Ctsl:3, Type:0, State:true}
],




        ListSolicitud:[
{
codigo:1,
 fecha:"2020-08-03",
 solicitud:'1-scpo',
 beneficio:'CV PHARMA',
 banco: 'SRL	BANCO POPULAR DOMINICANO',
 valor: 5000,
 sucursal:{
      nombre:'Santiago',
      documento:{desc:'prueba'}
 }

}, 	

{
codigo:2,
 fecha:'2020-08-03',
 solicitud:'2-scpo',
 beneficio:'CV PHARMA',
 banco:'SRL	BANCO POPULAR DOMINICANO',
 valor:6669.63,
 sucursal:{
      nombre:'SantoDomoingo'
 }

}, 

{
codigo:3,
 fecha:'2020-08-03',
 solicitud:'3-scpo',
 beneficio:'HOSPITAL METROPOLITANO DE SANTIAGO',
 banco:'BANCO POPULAR DOMINICANO',
 valor:832577.01,
 sucursal:{
      nombre:'La romana'
 }

}, 
],



Cheques: {
        codigo: 0,
        moneda:null,
        Documento:null,
        referencia:"",
        concepto:"",
        Cuentabancaria:null,
        valor:0,
        tasa:0,
        fecha: new Date().toISOString().substr(0,10),
        activo: true,

        descripcion: "**OCHO MIL QUINIENTOS NOVENTA Y UN 00/100 RD **",
    
      },



interval: {},
      value: 0,

intt:0
        
    })



,
methods:{
  currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,RedondeoValor,
  RedondeoBasico,fechaNueva,getHoraActual,

close () {
        alert('Chip close clicked')
      },


  onClickOutside () {
      this.active = false
    },

obtenerDato(e){

console.log('datos datos')
console.log(e)

},

Ejecu(){

  this.interval = setInterval(() => {
        if (this.value === 100) {

          clearInterval(this.interval)
          return (this.value = 0)
        }
        this.value += 1

      }, this.intt)

console.log(this.intt)


},






descargar(){
 /* accept=".csv,.xlsx, .xls ,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/xml "*/
const data=this.datoOBj
const fileName='download'
const exportType=exportFromJSON.types.json
exportFromJSON({data,fileName,exportType})
},




// function 
imprimirPDFBase64(pdfBase64) {
  var pdfWindow = window.open('', '_blank');
  pdfWindow.document.write('<iframe id="iframe" width="100%" height="100%" src="data:application/pdf;base64,' + pdfBase64 + '"></iframe>');
  // pdfWindow.document.close();
  // const url = window.URL.createObjectURL(blob)
var url=`data:application/pdf;base64,` + pdfBase64 ;
const iframe = document.createElement('iframe');
 iframe.style.display = 'none';
 iframe.src = url;
 document.body.appendChild(iframe);
 iframe.contentWindow.print();

},


ImprimirPDF(){
var PDF="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"
  




  /*this.AprirSolicitudPendiente=true
//  window.frames['myiframe'].focus();
  window.frames['myiframe'].print();*/

 // this.imprimirPDFBase64(PDF)
 
 var datosBase64 = 'AQUÍ_VA_TU_CODIGO_BASE64';
var nombreArchivo = 'archivo.pdf';
this.descargarArchivoBase64(PDF, nombreArchivo);
//this.descargarArchivoBase64()

},

descargarArchivoBase64(data, nombreArchivo) {
  //var SRC="data:application/pdf;base64,"+e
    var link = document.createElement('a');
    link.download = nombreArchivo;
    //link.href = 'data:application/octet-stream;base64,' + data;
    link.href = 'data:application/pdf;base64,' + data;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
},



EJECPDF(){

  var PDF="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"


  
  EventBus.$emit("openPDF", PDF);

},


getDataNewService(){
     // -->/api/v1/info
    var LINK=`https://saludom.herokuapp.com`
    var TOKEN=`kiAefQsiTfgb0zQ2X2HCvpzAfjAK1ApS0pqbymwDO4EmJoShKuF5o1WjE6AY3G40ttHZ7SXUbb9U9N65V6vGua6bv1GwZr9mmgzasgMj0X5VUwnv09Gw5QwFHfSmASU1mw7JE1ytr4u37HIYdhaNqoYjO16DdEdpdwnmuP5ZieY8gDIxqGveSNa7qjPxSKWDVg0yTetYUufl2oH8Ss8kXC9FniT2PIhGVvm9fR9xTIdGkI2Nt5wY85PdzHWZgq0q`
    //var Qry=`/api/v1/info?q=ars,client,invoice`
    var Qry=this.qry

    var HEADER={
      //'Authorization': `Bearer ${TOKEN} `,
      'Content-Type': "application/json",
      //'API KEY':`${TOKEN}`
      'sd-api-key':`${TOKEN}`
// X-TENANT-ID: "pascual"
    }
  // { headers: this.$store.getters.GetheadersAxios } 
console.log('infoHEADER-->',HEADER)
// console.log('informacion-->',this.$store.getters.GetheadersAxios)
      this.$axios.get(LINK+Qry, 
          { headers: HEADER })
        .then((res) => {
          console.log('Info-Data-->',res.data)
        })
        .catch((error) => console.log(error));


    },

saveUpdatDataCliente(){

//console.log('Informacion-->',this.myJson.listCliente)
/*var head = this.$store.getters.GetheadersAxios
this.$axios
        .post(this.$hostname + this.$hName + "/importData/importarClienteSaludDominicano", this.myJson, { headers: head })
        .then(res => {
          this.alerta("Dato importado correctamente", "bien")
          EventBus.$emit("loading", false);

        })
        .catch((error) => {
              this.alerta("Dato no importado correctamente", "error")
            }
            );*/

},


openDialogPdfViewer(){
var PDF="data:application/pdf;base64,";
PDF+=``

this.dialogPdfViewer=true

var _this = this;
        setTimeout(function () {
          _this.$refs.RefComponentsPdfViewer.pdfViewer.isLoading=true
          _this.$refs.RefComponentsPdfViewer.pdfViewer.pdfSource=PDF;
          _this.$refs.RefComponentsPdfViewer.pdfViewer.archivoNombre='hola mundo';
          _this.$refs.RefComponentsPdfViewer.pdfViewer.isLoading=false
        }, 800);
},


getImgUrl() {

   //   var images = require("../assets/" + pet);
    var images 
    images = require("@/assets/log.png");
  //  if(this.form.cargaImg==null || this.form.cargaImg.length==0 ){
  //     images = require("@/assets/img/Nofoto.png");

  //  }else{
  //    if(this.form.imagen!=null){

  //      images=this.form.imagen

  //    }
  //  }
     //var images = require("https://cdn.vuetifyjs.com/images/cards/foster.jpg");
     // var images ="https://cdn.vuetifyjs.com/images/cards/foster.jpg"
      return images;
    },

    verArchivoInput(){

     // console.log('vienDoArchivo-->',this.archivoKey[0])
      
      //return

      /*EventBus.$emit("loading", true);
      var head = this.$store.getters.GetheadersAxios
      head["Content-Type"] = "multipart/form-data"
      head.usuario=this.$store.getters.GetdatosInfUsu.usuario.usuario
      this.formData = new FormData();
      this.formData.append('file', this.ArchivoActPrecio[0]);*/

//archivoKey
// Suponiendo que tienes un string  
let texto = "Este es el contenido de mi archivo txt.";  

// Crear un Blob a partir del string  
let blob = new Blob([texto], { type: 'text/plain' });  
//let blob = new Blob([texto], { type: 'text/xml' });  


// Crear un File a partir del Blob  
let archivo = new File([blob], "exito.txt", { type: 'text/plain' });  

// Crear un objeto DataTransfer para simular el input file  
let dataTransfer = new DataTransfer();  
dataTransfer.items.add(archivo);  

// Asignar el archivo al input  
//document.getElementById('archivoKey').files = dataTransfer.files;  
console.log('--archivo-->',dataTransfer.files[0])

        const file = dataTransfer.files[0];
        const url = URL.createObjectURL(file);  
        const a = document.createElement("a"); 
              a.href = url; 
              a.download = file.name
               a.click();
               URL.revokeObjectURL(url);

            /*const downloadLink = document.getElementById('download-link');  
            downloadLink.href = url;  
            downloadLink.download = file.name;  // Establece el nombre del archivo a descargar  
            downloadLink.style.display = 'block'
//this.archivoKey=dataTransfer

const url = window.URL.createObjectURL(xhr.response);  
        const a = document.createElement("a");  
        a.href = url;  
        a.download = "nombre_del_archivo.pdf"; // Cambia el nombre aquí  
        document.body.appendChild(a);  
        a.click();  
        a.remove(); */


},

async getPRFacturaRFCE(){
  var FACT=this.myJson.factura3
  console.log('myJson.factura',this.myJson.factura3)
  const resXMLvalidado =  this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLrFCE(FACT);
  const resXMLSellada = await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(resXMLvalidado);
  console.log('xml-->',resXMLSellada)
},


async getPRFacturaECF(){
  var FACT=this.myJson.factura3
  console.log('myJson.factura',this.myJson.factura3)
  const resXMLvalidado = this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLeCF(FACT);
  const resXMLSellada = await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(resXMLvalidado);
  console.log('xml-->',resXMLSellada)
},



async getAprovacion(){

  const resObjToken =  await this.$refs.RefPvDgiiFacturacionEletronica.getAprovacion();
 // this.token=JSON.stringify(resObjToken);
},

async getSemillaValidaGetToken(){


const resObjToken =  await this.$refs.RefPvDgiiFacturacionEletronica.getSemillaValidaGetToken();
this.token=JSON.stringify(resObjToken);
},



async getFacturaRFCE(){

  console.log('LaFActura-->',JSON.parse(this.objFactura))
  var FACT=JSON.parse(this.objFactura)
  const resXMLConvert = this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLrFCE(FACT);
  const resXMLSellada = await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(resXMLConvert);
  const reader = new FileReader();
  var xmlString=''; 
  var _this = this;
  var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
  var NombreXml=RNCEmisor.trim()+""+FACT.ncf.trim();

        (async () => { 
         /* xmlString= e.target.result;  
         console.log('xml-->',xmlString)*/
           let blob = new Blob([resXMLSellada], { type: 'application/xml' });
           let archivo = new File([blob], `${NombreXml}.xml`, { type: 'text/xml' });  
          // let archivo = new File([blob], "xmlpruebaxml.xml", { type: 'application/xml' });  
            let dataTransfer = new DataTransfer(); 
            dataTransfer.items.add(archivo); 
            /*Descargado el archivo*/ 
            /**/const file = dataTransfer.files[0];
            const url = URL.createObjectURL(file);  
             const a = document.createElement("a"); 
              a.href = url; 
              a.download = file.name
              a.click();
              URL.revokeObjectURL(url);/**/
            })()
            
     /* reader.onload = function(e) {   };
    reader.readAsText(file);*/

 /* var FACT=this.myJson.factura3
  console.log('myJson.factura',this.myJson.factura3)
  const resXMLvalidado =  this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLrFCE(FACT);
  const resXMLSellada = await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(resXMLvalidado);
  console.log('xml-->',resXMLSellada)*/
},


async getFacturaECF(){

console.log('LaFActura-->',JSON.parse(this.objFactura))
var FACT=JSON.parse(this.objFactura)
const resXMLConvert = this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLeCF(FACT);
const resXMLSellada = await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(resXMLConvert);
const reader = new FileReader();
var xmlString=''; 
var _this = this;


      (async () => { 
       /* xmlString= e.target.result;  
       console.log('xml-->',xmlString)*/
         let blob = new Blob([resXMLSellada], { type: 'application/xml' });
         let archivo = new File([blob], "xmlECF.xml", { type: 'text/xml' });  
        // let archivo = new File([blob], "xmlpruebaxml.xml", { type: 'application/xml' });  
          let dataTransfer = new DataTransfer(); 
          dataTransfer.items.add(archivo); 
          /*Descargado el archivo*/ 
          /**/const file = dataTransfer.files[0];
          const url = URL.createObjectURL(file);  
           const a = document.createElement("a"); 
            a.href = url; 
            a.download = file.name
            a.click();
            URL.revokeObjectURL(url);/**/
          })()
          
},


soloFacXMLECF(){

var FACT=JSON.parse(this.objFactura)
const resXMLConvert = this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLeCF(FACT);
//const resXMLSellada = await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(resXMLConvert);
const reader = new FileReader();
var xmlString=''; 
var _this = this;
var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var NombreXml=RNCEmisor.trim()+""+FACT.ncf.trim();

      (async () => { 
         let blob = new Blob([resXMLConvert], { type: 'application/xml' });
         let archivo = new File([blob], `${NombreXml}.xml`, { type: 'text/xml' });   
          let dataTransfer = new DataTransfer(); 
          dataTransfer.items.add(archivo); 
          /*Descargado el archivo*/ 
          /**/const file = dataTransfer.files[0];
          const url = URL.createObjectURL(file);  
           const a = document.createElement("a"); 
            a.href = url; 
            a.download = file.name
            a.click();
            URL.revokeObjectURL(url);/**/
          })()
          
},

async soloFacXMLRFCE(){

var FACT=JSON.parse(this.objFactura)
const resXMLConvert = this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLrFCE(FACT);
//const resXMLSellada = await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(resXMLConvert);
const reader = new FileReader();
var xmlString=''; 

var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var eNCF=FACT.ncf.trim()
var NombreXml=RNCEmisor+eNCF

var _this = this;
      (async () => { 
         let blob = new Blob([resXMLConvert], { type: 'application/xml' });
         let archivo = new File([blob], `${NombreXml}.xml`, { type: 'text/xml' });   
          let dataTransfer = new DataTransfer(); 
          dataTransfer.items.add(archivo); 
          /*Descargado el archivo*/ 
          /**/const file = dataTransfer.files[0];
          const url = URL.createObjectURL(file);  
           const a = document.createElement("a"); 
            a.href = url; 
            a.download = file.name
            a.click();
            URL.revokeObjectURL(url);/**/
          })()
          
},

async getService(){
//bearer

var obj={
    "token": "bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiMDMxMDA0NjE3NTkiLCJqdGkiOiIzYTAyMmZmMy01OTI5LTRkYmMtOGU3NC02MTI4ZWYxOWVlMGMiLCJuYmYiOjE3MjY2NjIzODMsImV4cCI6MTcyNjY2NTk4MywiaXNzIjoiREdJSS5GRSIsImF1ZCI6IlVTVUFSSU9TLkRHSUkuRkUifQ.F_PHqBr9sYESX8i0kKzf5URg_6qmI-4TLFTibqwYJJ8",
    "expira": "2024-09-18T13:26:23Z",
    "expedido": "2024-09-18T12:26:23Z"
}
console.log('elObje-->',obj)
  const file = this.archivoKey[0]; // Obtener el archivo seleccionado  
    const reader = new FileReader();
    var xmlString=''; 
    var _this = this;
    reader.onload = function(e) {  
        (async () => { 
          xmlString= e.target.result;  
         console.log('xml-->',xmlString)
        const resXMLsellado =  await _this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(xmlString);
           let blob = new Blob([resXMLsellado], { type: 'application/xml' });
           let archivo = new File([blob], "xmlfactsellada.xml", { type: 'text/xml' });  
          // let archivo = new File([blob], "xmlpruebaxml.xml", { type: 'application/xml' });  
            let dataTransfer = new DataTransfer(); 
            dataTransfer.items.add(archivo); 
            /*Descargado el archivo*/ 
            /**/const file = dataTransfer.files[0];
            const url = URL.createObjectURL(file);  
             const a = document.createElement("a"); 
              a.href = url; 
              a.download = file.name
              a.click();
              URL.revokeObjectURL(url);/**/
            })()
            
      };
    reader.readAsText(file);
    
   //const resXMLsellado =  await this.$refs.RefPvDgiiFacturacionEletronica.firmarArchivoXML(res.data);
    //console.log('xml-->',resXMLvalidado)

},

    getService1(){

      //this.verArchivoInput()
      //return

     // -->/api/v1/info
    // this.getSemilla()

    this.$refs.RefPvDgiiFacturacionEletronica.getSemilla();
       

     return
    var LINK=``
  
    var Qry=this.dgiUrl

    var HEADER={
      //'Authorization': `Bearer ${TOKEN} `,
      'Content-Type': "application/json",
      //'API KEY':`${TOKEN}`
    // X-TENANT-ID: "pascual"
    }
  // { headers: this.$store.getters.GetheadersAxios } 
console.log('infoHEADER-->',HEADER)
// console.log('informacion-->',this.$store.getters.GetheadersAxios)
     /* this.$axios.get(LINK+Qry, 
          { headers: HEADER })
        .then((res) => {console.log(res.data)
          console.log('Info-Data-->',res.data)
        })
        .catch((error) => console.log(error));*/


      // XML en formato de cadena  
/*const xmlString = `  
<?xml version="1.0" encoding="UTF-8"?>  
<libros>  
    <libro>  
        <titulo>El Alquimista</titulo>  
        <autor>Paulo Coelho</autor>  
        <anio>1988</anio>  
    </libro>  
    <libro>  
        <titulo>Cien años de soledad</titulo>  
        <autor>Gabriel García Márquez</autor>  
        <anio>1967</anio>  
    </libro>  
</libros>  
`;  */ 


// Libreria 1
/*var convert = require('xml-js');
var xml =
'<?xml version="1.0" encoding="utf-8"?>' +
'<note importance="high" logged="true">' +
'    <title>Happy</title>' +
'    <todo>Work</todo>' +
'    <todo>Play</todo>' +
'</note>';
var result1 = convert.xml2json(xml, {compact: true, spaces: 4});
var result2 = convert.xml2json(xml, {compact: false, spaces: 4});*/
// console.log(result1, '\n', result2);

// var result1 = convert.xml2json(xmlString, {compact: true, spaces: 4});
// var result2 = convert.xml2json(xmlString, {compact: false, spaces: 4});
/*console.log(result1);*/
// fin Libreria 1
//this.ConvertirXMLaJSON(xmlString)

//*-Objto a XML
/*var xml2js = require('xml2js');
var obj = {name: "Super", Surname: "Man", age: 23};
var builder = new xml2js.Builder();
var xml = builder.buildObject(obj);
console.log(xml)*/

//var url1='https://eCF.dgii.gov.do/testecf/autenticacion/api/autenticacion/semilla'
//*--Prueva 1
// this.$axios.get(url1, 
//           { headers: HEADER })
//         .then((res) => {
//           /*console.log(res.data)
//           console.log('Info-Data-->',res.data)*/
//           var convert = require('xml-js');
//           //var result1 = convert.xml2json(res.data, {compact: true, spaces: 4});
//           var result1 = convert.xml2js(res.data, {compact: true, spaces: 0});
//           console.log(result1)
//           console.log('OBJFCH-->', result1.SemillaModel.fecha._text)
//           console.log('OBJVFALOR-->', result1.SemillaModel.valor._text)

//           var result2 = convert.js2xml(result1, {compact: true, spaces: 0});
//           console.log('xml-->', result1)

//         })
//         .catch((error) => console.log(error));

//**--file
/*console.log('File-->',this.archivoKey)
var DATA_KEY=new FormData();
DATA_KEY.append('file', this.archivoKey[0]);

console.log('informac-->',DATA_KEY)

var head = this.$store.getters.GetheadersAxios
    head["Content-Type"] = "multipart/form-data"
    head.usuario=this.$store.getters.GetdatosInfUsu.usuario.usuario
    var DATA_KEY=new FormData();
    DATA_KEY.append('file', this.archivoKey[0]);*/

    /* convertir string a archivo xml
    const xmlString = res.data;  
    const blob = new Blob([xmlString], { type: 'application/xml' });  
    const fileUrl = URL.createObjectURL(blob); 
    var formData = new FormData();
    formData.append('file', fileUrl[0]);

      var HheadD = this.$store.getters.GetheadersAxios
      HheadD["Content-Type"] = "multipart/form-data"
      HheadD.usuario=this.$store.getters.GetdatosInfUsu.usuario.usuario
    */ 

    /* convertir en base64
          // var xmlString = '<root><element>value</element></root>';  
         var xmlString = res.data
         var base64String = btoa(unescape(encodeURIComponent(xmlString)));  
        //  console.log(base64String); res.data
        */
       
        var HEADER2={
      //'Authorization': `Bearer ${TOKEN} `,
      // 'Content-Type': "application/json",
      'Content-Type': "multipart/form-data",
      //'accept': "application/json",
      // 'Content-Type': "application/xml",
      //'Content-Type': 'text/xml',
      // 'Content-Type': "text/html; charset=utf-8",
      //'API KEY':`${TOKEN}`
    // X-TENANT-ID: "pascual"
    } 

var url1='https://eCF.dgii.gov.do/testecf/autenticacion/api/autenticacion/semilla'
this.$axios.get(url1, 
          { headers: HEADER })
        .then((res) => {
          console.log('xml-->',res.data)
          /*convertir string a archivo xml*/
    // var xmlString = '<root><element>value</element></root>';  
          var xmlString = res.data
         //var base64String = btoa(unescape(encodeURIComponent(xmlString)));  
        //  console.log(base64String); res.data

      this.$axios
        .post(this.$hostname + this.$hName + "/importData/pruebafimaDgi",res.data , { headers: HEADER })
        .then(res1 => {

          this.varlidarSemilla(res1.data)
           // let texto = res1.data
           // let blob = new Blob([texto], { type: 'application/xml' });
           // let archivo = new File([blob], "xmlpruebaxml.xml", { type: 'text/xml' });  
          // let archivo = new File([blob], "xmlpruebaxml.xml", { type: 'application/xml' });  
          // let dataTransfer = new DataTransfer(); 
          //  dataTransfer.items.add(archivo); 
            /*Descargado el archivo*/ 
           // /**/const file = dataTransfer.files[0];
           /* const url = URL.createObjectURL(file);  
             const a = document.createElement("a"); 
              a.href = url; 
              a.download = file.name
              a.click();
              URL.revokeObjectURL(url);*/

 
        
    

        })
        .catch((error) => {this.alerta("Dato no importado correctamente", "error")});

          })
          .catch((error) => console.log(error));

return

//*--Prueva 2
var HEADER2={
      //'Authorization': `Bearer ${TOKEN} `,
      // 'Content-Type': "application/json",
      'Content-Type': "multipart/form-data",
      'accept': "application/json",
      // 'Content-Type': "application/xml",
      'Content-Type': 'text/xml',
      // 'Content-Type': "text/html; charset=utf-8",
      //'API KEY':`${TOKEN}`
    // X-TENANT-ID: "pascual"
    } 
var url1='https://eCF.dgii.gov.do/testecf/autenticacion/api/autenticacion/semilla'
this.$axios.get(url1, 
          { headers: HEADER })
        .then((res) => {
          console.log('xml-->',res.data)
          var url2='https://ecf.dgii.gov.do/testecf/autenticacion/api/autenticacion/validarsemilla'
          this.$axios.post(url2,res.data,{ headers: HEADER2 })
        .then((res) => {
            console.log('verificar-->',res.data)
        })
        .catch((error) => console.log(error));

        })
        .catch((error) => console.log(error));

    },


  async getSemilla(){
  var AMBIENTE='testecf'
  var HEADER={'Content-Type': "application/json" }
  var url1=`https://eCF.dgii.gov.do/${AMBIENTE}/autenticacion/api/autenticacion/semilla`
  this.$axios.get(url1, 
          { headers: HEADER })
        .then((res) => {
          (async () => {  
          const resXMLsellado =  await this.firmarArchivoXML(res.data);
          console.log('Antes-->')
          const resXMLvalidado =  await this.varlidarSemilla(resXMLsellado);
          console.log('xml-->',resXMLvalidado)
          console.log('Despues-->')

          })()
      //  
          })
          .catch((error) => console.log(error));

},



async firmarArchivoXML(XMLSTRING){
  var HEADER={'Content-Type': "application/json" }
return  new Promise((resolve, reject) => {
  this.$axios
        .post(this.$hostname + this.$hName + "/importData/pruebafimaDgi",XMLSTRING , { headers: HEADER })
        .then(res1 => {
          resolve(res1.data)
        })
        .catch((error) => {
          this.alerta("sello no generado", "error")
          resolve(null)
        });
  });

},



async varlidarSemilla(XML){

  return  new Promise((resolve, reject) => {  
    var AMBIENTE='testecf'
    let texto = XML
  let blob = new Blob([texto], { type: 'application/xml' });
  const formData = new FormData();  
  formData.append('xml', blob, 'data.xml');      
        var headHEAD={} ;
         headHEAD["Content-Type"] = "multipart/form-data"
         headHEAD["accept"]= "application/json"
         var url2=`https://ecf.dgii.gov.do/${AMBIENTE}/autenticacion/api/Autenticacion/ValidarSemilla`
          this.$axios.post(url2,formData,{ headers: headHEAD })
        .then((resss) => {
          resolve(resss.data)
         })
         .catch((error) => {
          this.alerta("DATA XML NO VALIDADO", "error")
          resolve(null)
        });

  });
},




ConvertirXMLaJSON(xmlString){

// Crear una instancia de DOMParser  
const parser = new DOMParser();  

// Parsear el XML a un documento XML  
const xmlDoc = parser.parseFromString(xmlString, "application/xml");
// Manejar posibles errores de parseo  
const parseError = xmlDoc.getElementsByTagName("parsererror");  

if (parseError.length > 0) {  
    console.error("Error al parsear el XML:", parseError[0].textContent);  
} else {  
    // Acceder a los elementos del XML  
    const libros = xmlDoc.getElementsByTagName("libro");  
    for (let libro of libros) {  
        const titulo = libro.getElementsByTagName("titulo")[0].textContent;  
        const autor = libro.getElementsByTagName("autor")[0].textContent;  
        const anio = libro.getElementsByTagName("anio")[0].textContent;  
        console.log(`Título: ${titulo}, Autor: ${autor}, Año: ${anio}`);  
    }  
} 


},



convertirBase64(){
  const file = this.archivoKey[0]; // Obtener el archivo seleccionado  
  console.log('Viendp-->',file)
  console.log('Nombre-->',file.name.substr(0,6))
  //const file = inputFile.files[0];  
  const reader = new FileReader();
  var _this = this;

    this.getBase64(file).then(base64 => {  
      var HEADER={'Content-Type': "application/json" }
      console.log(base64);  
      this.$axios
        .post(this.$hostname + this.$hName + "/importData/pruebafimaDgiBASE64",base64 , { headers: HEADER })
        .then(res1 => {
          console.log('res1-->',res1.data)
         // return res1.data
          resolve(res1.data)
        })
        .catch((error) => {
          this.alerta("sello no generado", "error")
          //return null;
          resolve(null)
        });

        
    }).catch(error => {  
        console.error(error);  
    });  


},


soloImpFac(){
  
var caja={"codigo":1,"descripcion":"Caja 1","puertoimpresora":null,"puertocashdrawer":null,"puertopoledisplay":null,"rutaprinter1":null,"rutaprinter2":null,"cajaconsulta":true,"formatoimpresioncontado":"rolloT","formatoimpresioncredito":null,"deposito":2000,"cobradora":true,"soloBarra":false,"borrado":false,"veryFoms":false,"marca":false,"almacen":{"codigo":1,"descripcion":"Almacen Principal                                                                                                                                                                                       ","cuentacontable":"                              ","desactivado":false,"fechaCreacion":1493089316836,"fechaModificacion":1725379010780,"usuarioCreacion":"MarcoS","usuarioModificacion":"pascual","principal":true,"devolucion":false,"borrado":false,"pedidosya":true,"idpedidoya":"p0505","referenciaImportacion":null,"ubberEats":true,"idubberEats":"u0505","nuevaFechaCreacion":"2017-04-24"},"sucursal":{"codigo":1,"descripcion":"Sucursal Principal","empresa":null,"activada":true,"direccion":"Santiago, Republica Dominicana","telefono":"(809)582-0000       ","rnc":null,"metadeventas":1500,"otrosIngresos":6,"documentorecibo":1,"documentofacturacion":1,"documentofacturacredito":2,"documentoDevolucion":5,"documentoNotaCredito":3,"almacen":1,"documentoEntrada":2,"documentoSalida":3,"dncd":"25987","ciudad":"Santiago","documentoConduce":13,"borrado":false,"docrecibo":{"empresa":1,"codigo":1,"descripcion":"Recibo de Ingreso Cliente","secuenciainicial":1,"cantidadcopias":3,"operacion":9,"nombrecorto":"Ri   ","activo":true,"fechaCreacion":1493762066766,"fechaModificacion":1700686014157,"usuarioCreacion":"MarcoS","usuarioModificacion":"MarcoS","comprobante":false,"borrado":false,"documentocxcCatalogoList":[{"documentocxcCatalogoPK":{"cuenta":"2-1-01-03-04                  ","documento":1},"tipo":4,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"2-1-01-03-04                  ","descripcion":"Itbis Retenido por Pagar","origen":"C  ","tipo":"DE ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01-03                     ","descripcion":"IMPUESTOS POR PAGAR","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01                        ","descripcion":"DOCUMENTOS POR PAGAR CORTO PLAZO","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1                           ","descripcion":"PASIVOS CIRCULANTES","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2","descripcion":"PASIVOS Y PATRIMONIOS","origen":"C","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"2-1-01-03-02                  ","documento":1},"tipo":11,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"2-1-01-03-02                  ","descripcion":"ISR Retenciones","origen":"C  ","tipo":"DE ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01-03                     ","descripcion":"IMPUESTOS POR PAGAR","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01                        ","descripcion":"DOCUMENTOS POR PAGAR CORTO PLAZO","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1                           ","descripcion":"PASIVOS CIRCULANTES","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2                             ","descripcion":"PASIVOS Y PATRIMONIOS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"1-1-01-01-01                  ","documento":1},"tipo":2,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"1-1-01-01-01                  ","descripcion":"Caja General RD$","origen":"D  ","tipo":"DE ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-01-01                     ","descripcion":"EFECTIVO EN CAJA","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-01                        ","descripcion":"EFECTIVO EN CAJA Y BANCOS","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1                           ","descripcion":"ACTIVOS CORRIENTES","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1                             ","descripcion":"ACTIVOS","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"4-1-01-01-50                  ","documento":1},"tipo":5,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"4-1-01-01-50                  ","descripcion":"Descuentos Sobre Ventas","origen":"D  ","tipo":"DE ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4-1-01-01                     ","descripcion":"VENTAS NETAS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4-1-01                        ","descripcion":"INGRESOS OPERACIONALES NETOS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4-1                           ","descripcion":"INGRESOS OPERACIONALES","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4                             ","descripcion":"INGRESOS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"1-1-02-02-01                  ","documento":1},"tipo":1,"debito":false,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"1-1-02-02-01                  ","descripcion":"Cuentas por Cobrar - Clientes","origen":"D  ","tipo":"DE ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-02-02                     ","descripcion":"CUENTAS POR COBRAR CLIENTES","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-02                        ","descripcion":"CUENTAS POR COBRAR","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1                           ","descripcion":"ACTIVOS CORRIENTES","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1                             ","descripcion":"ACTIVOS","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}}],"operaciones":{"codigo":9,"empresa":1,"descripcion":"Recibo de Ingresos","modulo":"CXC                           ","sumaBalance":false,"borrado":false,"cierreanual":false},"nuevaFechaCreacion":"2017-05-02"}},"cajadomicilio":true,"vendedor":null,"formatoImprecionConduce":"rollo"}
var FACT=JSON.parse(this.objFactura)
var fechafirmadgii=FACT.fechafirmadgii.trim().replaceAll(' ', '%20')
var RNCEmisor = this.$store.getters.GetConfiguracionGeneral.config.rnc.trim().replace("-", "").replace(/-/g,'');
var eNCF=FACT.ncf.trim()
var MontoTotal= FACT.valor;
FACT.fechafirmadgii=`${this.FormatoFecha(this.fechaNueva())} ${this.getHoraActual().substr(0,5)}:00`
//eCF
// FACT.qrdgii=`https://ecf.dgii.gov.do/CerteCF/consultatimbre?rncemisor=130412881&rnccomprador=131880681&encf=${FACT.ncf.trim()}&fechaemision=${this.FormatoFecha(FACT.nuevaFecha)}&montototal=${FACT.valor}&fechafirma=${fechafirmadgii}&codigoseguridad=130485`;
//RFCE
FACT.qrdgii=` https://fc.dgii.gov.do/testecf/consultatimbrefc?rncemisor=${RNCEmisor}&encf=${eNCF}&montototal=${MontoTotal}&codigoseguridad=130485`;
console.log('QR--->',FACT.qrdgii)
var config=this.$store.getters.GetConfiguracionGeneral
  if (localStorage.printerSelect != null) {}
                    var selectImpre=(localStorage.printerSelect!=undefined?JSON.parse(localStorage.printerSelect):null)
            var impresora=null
            if(selectImpre!=null && selectImpre.hasOwnProperty('nombre')){
              impresora=JSON.parse(localStorage.printerSelect).nombre
              }
                      var msg = {
                        accion: "print",
                        formato: caja.formatoimpresioncontado.trim(),
                        impresora: impresora,
                        data: config,
                        fac: FACT,
                        caja: caja,
                      };
                      this.imprimir(msg, "factura");
                    

},


buscarSingn(){
  var HEADER={'Content-Type': "application/json" }
  //this.$store.getters.GetheadersAxios
  
  this.$axios.get(this.$hostname + this.$hName + "/fe/Autenticacion/ValidarSemilla", { headers: HEADER })
        .then(res => {
         // return res1.data
         console.log('Inf-REsp->',res.data)
        })
        .catch((error) => {
          //return null;
          console.log('Inf-REsp->',error)
        });


  // this.$axios.get(this.$hostname + this.$hName + "/fe/Autenticacion/ValidarSemilla", { headers: HEADER }).then(res => {
  //       // this.RSucursal = JSON.parse(JSON.stringify(res.data));
  //       console.log('Inf-REsp->',res.data)
     
  //     });

  // this.$axios
  //       .post(this.$hostname + this.$hName + "/fe/Autenticacion/ValidarSemilla", { headers: HEADER })
  //       .then(res1 => {
  //        // return res1.data
  //         resolve(res1.data)
  //       })
  //       .catch((error) => {
  //         this.alerta("sello no generado", "error")
  //         //return null;
  //         resolve(null)
  //       });



  return
var String=`
<ECF>
  <Encabezado>
    <Version>1.0</Version>
    </Encabezado>
    <Signature xmlns="http://www.w3.org/2000/09/xmldsig#">
<SignedInfo>
<CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"/>
<SignatureMethod Algorithm="http://www.w3.org/2001/04/xmldsig-more#rsa-sha256"/>
<Reference URI="">
<Transforms>
<Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature"/>
</Transforms>
<DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"/>
<DigestValue>3T5dkeZkyFspK+Xo06UYIRDBTzca7HSZSK+qHNf0N2o=</DigestValue>
</Reference>
</SignedInfo>
<SignatureValue>D2ZCbgzE7QN4Ss3T1H8gHRtvth3oPFV3YHbMkgM1aSI4EhQI4E1QRcS5RqO6cnlSB0kkOD2LgQagJlUs+BRqfHu1bj2XAef5nYyvP1cBr7rOQs3QrWrIjwX3EoeuygRjMQq30MfathIDXfZ4mM9tZoZd+IlojRAmJWLKG8fn9BWkr2ry8wmQqqxNUIQ3JUxGBk33lSYGPf4qkpxDSEBRl5AvacyVbBn3vrHjCGLhPnyDJGpy+FwUU+rUADjy14qDIe5WAWlbsRZtvv5QNFa5AGDNdrcOHzpKVsb2b8hD4hHX7UlMUIYEajS3G1gYSmwpF+wq1YYZJpEWDgLEMcX4cw==</SignatureValue>
<KeyInfo>
<X509Data>
<X509Certificate>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</X509Certificate>
</X509Data>
</KeyInfo>
</Signature>
</ECF>
`

  console.log("Inform 2-->",String.split("<SignatureValue>")[1].substr(0,6))
//
//var ano = parseInt(fecper.toLocaleDateString().split("/")[2]);



},

soloImpNOTA(){

  var caja={"codigo":1,"descripcion":"Caja 1","puertoimpresora":null,"puertocashdrawer":null,"puertopoledisplay":null,"rutaprinter1":null,"rutaprinter2":null,"cajaconsulta":true,"formatoimpresioncontado":"rolloT","formatoimpresioncredito":null,"deposito":2000,"cobradora":true,"soloBarra":false,"borrado":false,"veryFoms":false,"marca":false,"almacen":{"codigo":1,"descripcion":"Almacen Principal                                                                                                                                                                                       ","cuentacontable":"                              ","desactivado":false,"fechaCreacion":1493089316836,"fechaModificacion":1725379010780,"usuarioCreacion":"MarcoS","usuarioModificacion":"pascual","principal":true,"devolucion":false,"borrado":false,"pedidosya":true,"idpedidoya":"p0505","referenciaImportacion":null,"ubberEats":true,"idubberEats":"u0505","nuevaFechaCreacion":"2017-04-24"},"sucursal":{"codigo":1,"descripcion":"Sucursal Principal","empresa":null,"activada":true,"direccion":"Santiago, Republica Dominicana","telefono":"(809)582-0000       ","rnc":null,"metadeventas":1500,"otrosIngresos":6,"documentorecibo":1,"documentofacturacion":1,"documentofacturacredito":2,"documentoDevolucion":5,"documentoNotaCredito":3,"almacen":1,"documentoEntrada":2,"documentoSalida":3,"dncd":"25987","ciudad":"Santiago","documentoConduce":13,"borrado":false,"docrecibo":{"empresa":1,"codigo":1,"descripcion":"Recibo de Ingreso Cliente","secuenciainicial":1,"cantidadcopias":3,"operacion":9,"nombrecorto":"Ri   ","activo":true,"fechaCreacion":1493762066766,"fechaModificacion":1700686014157,"usuarioCreacion":"MarcoS","usuarioModificacion":"MarcoS","comprobante":false,"borrado":false,"documentocxcCatalogoList":[{"documentocxcCatalogoPK":{"cuenta":"2-1-01-03-04                  ","documento":1},"tipo":4,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"2-1-01-03-04                  ","descripcion":"Itbis Retenido por Pagar","origen":"C  ","tipo":"DE ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01-03                     ","descripcion":"IMPUESTOS POR PAGAR","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01                        ","descripcion":"DOCUMENTOS POR PAGAR CORTO PLAZO","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1                           ","descripcion":"PASIVOS CIRCULANTES","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2","descripcion":"PASIVOS Y PATRIMONIOS","origen":"C","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"2-1-01-03-02                  ","documento":1},"tipo":11,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"2-1-01-03-02                  ","descripcion":"ISR Retenciones","origen":"C  ","tipo":"DE ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01-03                     ","descripcion":"IMPUESTOS POR PAGAR","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1-01                        ","descripcion":"DOCUMENTOS POR PAGAR CORTO PLAZO","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2-1                           ","descripcion":"PASIVOS CIRCULANTES","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"2                             ","descripcion":"PASIVOS Y PATRIMONIOS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"PA ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"1-1-01-01-01                  ","documento":1},"tipo":2,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"1-1-01-01-01                  ","descripcion":"Caja General RD$","origen":"D  ","tipo":"DE ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-01-01                     ","descripcion":"EFECTIVO EN CAJA","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-01                        ","descripcion":"EFECTIVO EN CAJA Y BANCOS","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1                           ","descripcion":"ACTIVOS CORRIENTES","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1                             ","descripcion":"ACTIVOS","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"4-1-01-01-50                  ","documento":1},"tipo":5,"debito":true,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"4-1-01-01-50                  ","descripcion":"Descuentos Sobre Ventas","origen":"D  ","tipo":"DE ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4-1-01-01                     ","descripcion":"VENTAS NETAS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4-1-01                        ","descripcion":"INGRESOS OPERACIONALES NETOS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4-1                           ","descripcion":"INGRESOS OPERACIONALES","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"4                             ","descripcion":"INGRESOS","origen":"C  ","tipo":"CO ","tipogasto":null,"grupo":"IN ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}},{"documentocxcCatalogoPK":{"cuenta":"1-1-02-02-01                  ","documento":1},"tipo":1,"debito":false,"borrado":false,"catalogocuentas":{"empresa":0,"cuenta":"1-1-02-02-01                  ","descripcion":"Cuentas por Cobrar - Clientes","origen":"D  ","tipo":"DE ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-02-02                     ","descripcion":"CUENTAS POR COBRAR CLIENTES","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1-02                        ","descripcion":"CUENTAS POR COBRAR","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1-1                           ","descripcion":"ACTIVOS CORRIENTES","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":{"empresa":0,"cuenta":"1                             ","descripcion":"ACTIVOS","origen":"D  ","tipo":"CO ","tipogasto":null,"grupo":"AC ","departamento":null,"activo":true,"borrado":false,"cuentaGubernamental":null,"descargo":null,"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"gasto":null,"balance":null},"moneda":{"codigo":1,"descripcion":"Peso Dominicano                                   ","nombrecorto":"RD                  ","tasa":1,"activada":true,"tasaCompra":1,"tasaVenta":1,"borrado":false}}],"operaciones":{"codigo":9,"empresa":1,"descripcion":"Recibo de Ingresos","modulo":"CXC                           ","sumaBalance":false,"borrado":false,"cierreanual":false},"nuevaFechaCreacion":"2017-05-02"}},"cajadomicilio":true,"vendedor":null,"formatoImprecionConduce":"rollo"}
  var FACT=JSON.parse(this.objFactura)
  var fechafirmadgii=FACT.fechafirmadgii.trim().replaceAll(' ', '%20')
  FACT.qrdgii=`https://ecf.dgii.gov.do/CerteCF/consultatimbre?rncemisor=130412881&rnccomprador=131880681&encf=${FACT.ncf.trim()}&fechaemision=${this.FormatoFecha(FACT.nuevaFecha)}&montototal=${FACT.valor}&fechafirma=${fechafirmadgii}&codigoseguridad=130485`;
  var config=this.$store.getters.GetConfiguracionGeneral
    if (localStorage.printerSelect != null) {}
                      var selectImpre=(localStorage.printerSelect!=undefined?JSON.parse(localStorage.printerSelect):null)
              var impresora=null
              if(selectImpre!=null && selectImpre.hasOwnProperty('nombre')){
                impresora=JSON.parse(localStorage.printerSelect).nombre
                }
                        var msg = {
                          accion: "print",
                          formato: caja.formatoimpresioncontado.trim(),
                          impresora: impresora,
                          data: config,
                          devolucion: FACT,
                          caja: caja,
                        };
                        this.imprimir(msg, "devolucion");
                      
  
  },





 // Envío de una solicitud POST al servidor con los datos a imprimir.
 imprimir(datos, operacion) {
      datos.operacion = operacion;
      if (datos.formato.trim() === "rolloBlue") {
if(datos.operacion.trim()==="factura"){
var FACT=datos.fac.hasOwnProperty('factura')? datos.fac.factura.factura:datos.fac
var _this = this;
setTimeout(function () {
  _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(FACT)
  // _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(datos.fac.factura.factura)
}, 800);
       
}

      }else{
        if(datos.impresora==null){
          this.alerta(" seleccione la impresora","error")
          return
        }

        if (datos.formato === "fiscale") {
        this.$axios.get("http://localhost:15999/impresora/imprimir/validad").then(res => {
          if (res.data.LastError ===0) {
          this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
            this.limpiarPuntoVentaCompleto();
          })
          .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
          }else{
            this.alerta("La impresora esta desconectada o esta apagada!!!","error")
            return;
          }
        })
        .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
      }else{
        this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
            this.limpiarPuntoVentaCompleto();
          })
          .catch((error) => {
            console.error(error)
            this.ejecucion=true 
          });
      }

      }

      
    },


 getBase64(file) {  
    return new Promise((resolve, reject) => {  
        const reader = new FileReader();  
        reader.readAsDataURL(file);  
        reader.onload = () => resolve(reader.result);  
        reader.onerror = error => reject(error);  
    });  
},  



 convertP12ToBase64rrrr(file) {  
    const reader = new FileReader();  
    var _this = this;
    reader.onloadend = function() {  
        const base64data = reader.result;  
        console.log(base64data);  
        var HEADER={'Content-Type': "application/json" }
      console.log(base64data);  
      _this.$axios
        .post(_this.$hostname + _this.$hName + "/importData/pruebafimaDgiBASE64",base64data , { headers: HEADER })
        .then(res1 => {
          console.log('res1-->',res1.data)
         // return res1.data
          resolve(res1.data)
        })
        .catch((error) => {
          _this.alerta("sello no generado", "error")
          //return null;
          resolve(null)
        });

    };  
    reader.readAsDataURL(file);  
},


async convertP12ToBase64(file) {  
  var FACT=this.myJson.factura3
  const resXMLvalidado = this.$refs.RefPvDgiiFacturacionEletronica.FacturaXMLeCF(FACT);
    const reader = new FileReader();  
    var _this = this;
    reader.onloadend = function(e) {  
      var binaryData = e.target.result;
      var base64String = window.btoa(binaryData);
      console.log('base64-->',base64String);
      var HEADER={'Content-Type': "application/json" }
      var OBJData={
        fileObj:resXMLvalidado,
        base:base64String
      }
      //base64String
      _this.$axios
        .post(_this.$hostname + _this.$hName + "/importData/pruebafimaDgiBASE64",OBJData, { headers: HEADER })
        .then(res1 => {
          console.log('res1-->',res1.data)
         // return res1.data
          resolve(res1.data)
        })
        .catch((error) => {
          _this.alerta("sello no generado", "error")
          //return null;
          resolve(null)
        });



        /* const base64data = reader.result;  
        console.log(base64data);  
       var HEADER={'Content-Type': "application/json" }
      console.log(base64data);  
      _this.$axios
        .post(_this.$hostname + _this.$hName + "/importData/pruebafimaDgiBASE64",base64data , { headers: HEADER })
        .then(res1 => {
          console.log('res1-->',res1.data)
         // return res1.data
          resolve(res1.data)
        })
        .catch((error) => {
          _this.alerta("sello no generado", "error")
          //return null;
          resolve(null)
        });*/

    };  
    reader.readAsDataURL(file);  
},

getTobase64P12(){
  const file = this.archivoKeyBase64[0];
    //const file = event.target.files[0];  
    if (file && file.name.endsWith('.p12')) {  
        this.convertP12ToBase64(file);  
    } else {  
        console.log("Por favor, selecciona un archivo .p12");  
    }  

},



async getProcesoCompleto(){

 const resObjToken =  await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXMLeCF();
// this.token=JSON.stringify(resObjToken);

},


async getProcesoCompletoECF(){

var FACT=JSON.parse(this.objFactura)
const resObjCompleto =  await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF(FACT);
console.log('resObjCompleto-->',resObjCompleto)
this.token=JSON.stringify(resObjCompleto.ObjToken)
this.qrdgii=JSON.stringify(resObjCompleto.qrdgii)
},


async getProcesoCompletoRFCE(){

  var FACT=JSON.parse(this.objFactura)
const resObjToken =  await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_RFCE(FACT);
this.token=JSON.stringify(resObjToken)
this.token=JSON.stringify(resObjToken);


// console.log('Hola mundo-->',this.$hostname + this.$hName)
// // await this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: this.$store.getters.GetheadersAxios }).then(res => {
// //     this.RSucursal = JSON.parse(JSON.stringify(res.data));
// //   });



// try {
//          const response = await this.$axios.get('http://localhost:8080/api/external-data',{headers: this.$store.getters.GetheadersAxios}).then(res => {
//     // this.RSucursal = JSON.parse(JSON.stringify(res.data));
//       console.log('REPSJnjb-->',res.data) 

//   })
//       //  console.log('REPSJnjb-->',response.data) 
        
//       } catch (error) {
//         console.error('Error al obtener datos:', error);
//       }


// try {
//         const response = await this.$axios.get('http://localhost:8080/api/external-data');
//         this.externalData = response.data;
//       } catch (error) {
//         console.error('Error al obtener datos:', error);
//       }




},


async facttemObjnoCoincide(){


var objfact=JSON.parse(this.objFactura)
console.log('inf-->',objfact)

  objfact.usuario=this.$store.getters.GetdatosInfUsu.usuario.usuario
          this.$axios.post(this.$hostname + this.$hName + "/temporales/save", objfact, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              this.alerta("Guardado corretamente...", "bien");
            })
            .catch((error) => this.alerta(error, "error"));

},

getSecuenciaAlfNum(){
 var SEC=''
for (let index = 0; index < 100; index++) {
if(index==0){ SEC='ZZ9990'}
  SEC = this.generarSecuencia(SEC).nuevaSecuencia
console.log('SEC:-->',SEC)
}


  
  

},



   generarSecuencia(secuenciaActual) {
    // Separar letras y números
    let letras = secuenciaActual.slice(0, 2);
    let numeros = parseInt(secuenciaActual.slice(2), 10);

    // Guardar la secuencia anterior
    const secuenciaAnterior = secuenciaActual;

    // Incrementar los números
    numeros++;

    if (numeros > 9999) {
        numeros = 1;

        // Incrementar las letras
        let primera = letras.charCodeAt(0);
        let segunda = letras.charCodeAt(1);

        segunda++;

        if (segunda > 90) { // 90 = 'Z'
            segunda = 65;   // 65 = 'A'
            primera++;
        }

        if (primera > 90) {
            // Reiniciar a AA0001 si pasa de ZZ
            primera = 65;
            segunda = 65;
        }

        letras = String.fromCharCode(primera) + String.fromCharCode(segunda);
    }

    // Formatear números con ceros a la izquierda
    const numerosStr = String(numeros).padStart(4, '0');

    // Nueva secuencia
    const nuevaSecuencia = letras + numerosStr;

    return { secuenciaAnterior, nuevaSecuencia };

    // Ejemplo de uso:
console.log(generarSecuencia("AA0364")); // { secuenciaAnterior: 'AA0364', nuevaSecuencia: 'AA0365' }
console.log(generarSecuencia("AA9999")); // { secuenciaAnterior: 'AA9999', nuevaSecuencia: 'AB0001' }
console.log(generarSecuencia("ZZ9999")); // { secuenciaAnterior: 'ZZ9999', nuevaSecuencia: 'AA0001' }
},

async getProcesoPr_ECF_NotaCredito(){
var doc= 2
var cod =8
//notacreditocliente/find/{codigo}/{documento}
  
 this.$axios.get(this.$hostname +this.$hName +"/notacreditocliente/find/"+cod+"/"+doc,
            { headers: this.$store.getters.GetheadersAxios },
          )
          .then( async (res) => 
          {
          /**/  var CodigoModificacion=3;
            var resObjCompleto = await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_NOTACREDITO(res.data,CodigoModificacion);
           console.log("resObjCompleto-->",resObjCompleto)
            console.log("RES.DATA-->",res.data)

          })
},

verEvent(event){
console.log('-*-->',event)
},

alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
      }
      if (l == "bien2") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
        this.aalert.right = true
        this.aalert.top = false
        this.aalert.timeout = 3000
        this.ejecucion = true
        //this.loading(false)

      }
      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);
        this.aalert.right = false
        this.aalert.top = true
        this.aalert.timeout = 120000
        this.ejecucion = true;
        //this.loading(false)
      }

      if (l == "warning") {
        (this.aalert.estado = true),
          (this.aalert.color = "warning"),
          (this.aalert.nombre = e);
        this.aalert.right = false
        this.aalert.top = true
        this.aalert.timeout = 5000
        this.ejecucion = true;
        //this.loading(false)
      }


    },


// async fetchData() {
//       try {
//         const response = await this.$axios.get('http://localhost:8080/api/external-data');
//         console.log('holaMundo-->',response.data);
//       } catch (error) {
//         console.error('Error al obtener datos:', error);
//       }
//     },


// FormatoFecha(params) {
//       if (params != null) {
//         if (params.length > 0) {
//           return (
//             params.substring(8, 10) +
//             "-" +
//             params.substring(5, 7) +
//             "-" +
//             params.substring(0, 4)
//           );
//         }
//       }
//     },

//     currencyFormatter(number) {
     

// if(number==null){number=0}
//       return number
//         .toFixed(2)
//         .toString()
//         .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
//     },

},
computed: {
  ActDescBtn() { 

    this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))

  }
}
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.fino-input.v-text-field.v-text-field--outlined.v-input--dense .v-input__control {
  min-height: 24px !important;  /* Menor altura */
  padding-top: -5px !important;
  padding-bottom: -5px !important;
}
.fino-input input {
  font-size: 11px;
  padding: -5px -5px !important;  /* Ajuste horizontal */
  height: 24px !important;
}
</style>